import axios from "../../lib/axiosInstance";

export async function fetchDepartments(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search?.trim()) queryParams.append("search", params.search.trim());

  const queryString = queryParams.toString();
  return axios
    .get(`/departments${queryString ? `?${queryString}` : ""}`)
    .then((res) => res.data);
}

export async function getDepartmentById(id) {
  return axios.get(`/departments/${id}`).then((res) => res.data);
}

export async function createDepartment(payload) {
  return axios.post(`/departments`, payload).then((res) => res.data);
}

export async function updateDepartment(payload) {
  return axios
    .patch(`/departments/${payload.id}`, {
      name: payload.name,
      description: payload.description,
      teamIds: payload.teamIds,
    })
    .then((res) => res.data);
}

export async function deleteDepartment(id) {
  return axios.delete(`/departments/${id}`).then((res) => res.data);
}
